import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { CKCheckbox } from 'clearkit';

import InfoTooltip from '~/components/InfoTooltip';
import Select from '~/components/SelectWithLabel';
import TextField from '~/components/TextField';

import styles from './styles.js';

const SECONDS = {
  months: 2592000,
  weeks: 604800,
  days: 86400,
};

class SupressionForm extends React.Component {
  constructor(props) {
    super(props);

    const suppressionFormState = this.getSuppressionFormState();

    this.state = {
      number: suppressionFormState.number,
      duration: suppressionFormState.duration,
      enabled: suppressionFormState.number > 0,
    };
  }

  toggleSuppression = () => {
    this.setState(
      (prevState) => {
        const enabled = !prevState.enabled;

        return {
          enabled,
        };
      },
      () => {
        this.calculateSeconds({
          number: this.state.enabled ? 1 : 0,
          duration: 'days',
        });
      },
    );
  };

  calculateSeconds = (formState) => {
    const numOfSeconds = SECONDS[formState.duration] * formState.number;

    this.setState(formState, () => {
      this.props.onChange({ exclusion_timeframe: numOfSeconds });
    });
  };

  getSuppressionFormState = () => {
    const { exclusion_timeframe } = this.props;

    if (!exclusion_timeframe || exclusion_timeframe === 0)
      return { number: 0, duration: 'days' };

    let result = {
      number: 0,
      duration: 'days',
    };
    let divisor;

    for (let key in SECONDS) {
      divisor = exclusion_timeframe / SECONDS[key];

      if (Number.isInteger(divisor) && divisor >= 1) {
        result = {
          number: divisor,
          duration: key,
        };
        break;
      }
    }

    return result;
  };

  render() {
    const { classes, typename } = this.props;
    const { enabled } = this.state;

    return (
      <div>
        <FormGroup row>
          <FormControlLabel
            control={
              <CKCheckbox
                className={classes.checkbox}
                id="toggle-supression"
                checked={enabled}
                onChange={this.toggleSuppression}
              />
            }
            classes={{ label: classes.checklabel }}
            label={
              <span className="flex items-center">
                <span>Enable delivery suppression</span>
                <InfoTooltip
                  title={`Reduce the noise - limit how often you are notified of the same ${typename}`}
                />
              </span>
            }
          />
        </FormGroup>

        {enabled && (
          <div className={classes.supressionForm}>
            <FormLabel style={{ margin: '10px 12px 0 0' }}>
              Only include {typename === 'person' ? 'people' : 'companies'} that
              haven’t been included in the past…
            </FormLabel>

            <div>
              <TextField
                className={classes.number}
                variant="standard"
                type="number"
                value={this.state.number}
                onChange={(e) =>
                  this.calculateSeconds({
                    ...this.state,
                    number: parseInt(e.target.value, 10),
                  })
                }
              />

              <Select
                value={this.state.duration}
                required
                autoWidth
                className={classes.select}
                classes={{ text: classes.selectLabel }}
                style={{ width: '110px' }}
                onChange={(e) =>
                  this.calculateSeconds({
                    ...this.state,
                    duration: e.target.value,
                  })
                }>
                <MenuItem className={classes.defaultItem} value="months">
                  months
                </MenuItem>
                <MenuItem className={classes.defaultItem} value="weeks">
                  weeks
                </MenuItem>
                <MenuItem className={classes.defaultItem} value="days">
                  days
                </MenuItem>
              </Select>
            </div>
          </div>
        )}
      </div>
    );
  }
}

SupressionForm.propTypes = {
  classes: PropTypes.object.isRequired,
  schedule_period: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  exclusion_timeframe: PropTypes.number.isRequired,
};

export default withStyles(styles)(SupressionForm);
